import { API_URL } from "@/settings";

const UrlBuilder = {
  GetPath(path) {
    return API_URL.replace(new RegExp("[/]+$"), "") + path;
  }
};

export default UrlBuilder;
